import { TerminalFilter as TerminalFilterBase } from 'components/tailwind-ui/TerminalFilter';
import * as React from 'react';
import { useFilterSearchParams } from '../../../utilities';

export const PortOfDestination: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);

  const setValues = (values: { portCodes: string[]; terminals: string[] }) => {
    setSearchParams({
      terminalPickupKeys: values.terminals,
      portPickupCodes: values.portCodes,
    });
  };

  const values = {
    portCodes: searchParams.portPickupCodes,
    terminals: searchParams.terminalPickupKeys,
  };

  return <TerminalFilterBase label="Port of Destination" values={values} setValues={setValues} />;
};
PortOfDestination.displayName = 'Shipments.Filters.PortOfDestination';
